exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-7735a1b2] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 3;\n}\n.scroll[data-v-7735a1b2] {\n  overflow-y: auto;\n}\n@media (max-width: 600px) {\n.configurator-button[data-v-7735a1b2] {\n    position: absolute;\n    bottom: 20px;\n    width: 90%;\n    margin: 0 auto;\n}\n}\n", ""]);

// exports
